import {
  Component,
  effect,
  inject,
  model,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { AppService } from '@shared/services/app.service';
import { CardEmpleado } from '@shared/components/card-empleado/card-empleado';
import { IEmpleadoData } from '@core/interfaces/entidades/empleado.entidad';
import { EmpleadoApiService } from '@core/services/api/empleado-api.service';
import { CrearEmpleado } from '@shared/components/crear-empleado/crear-empleado';
import { UiButton, UiDialog } from '@shared/components/ui';
import { SucursalService } from '@shared/services/sucursal.service';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-empleado',
  imports: [InputBuscador, UiButton, CardEmpleado, UiDialog, CrearEmpleado],
  templateUrl: './empleado.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './empleado.css',
})
export class Empleado implements OnInit {
  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.empleadoApiService.cargar().subscribe({
          next: (data) => {
            this.empleados.set(data);
            this.filtroEmpleados.set(data);
          },
          error: (err) => {
            if (err.status == 401) return;
            this.toastService.show(
              'top-right',
              'error',
              'Error al cargar los empleados',
              err.error.message || 'Ocurrió un error al cargar los empleados',
            );
          },
        });
      }
    });
  }

  // services
  private readonly appService = inject(AppService);
  private readonly empleadoApiService = inject(EmpleadoApiService);
  private readonly sucursalService = inject(SucursalService);
  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Equipo y Empleados',
      subtitle: 'Administra los perfiles, accesos y datos del personal de tu empresa.',
      showBackButton: true,
      icon: 'bi bi-people',
    });
  }

  // datos
  busquedaEmpleado = model<string>('');
  modal_crear_empleado = signal(false);
  empleados = signal<IEmpleadoData[]>([]);
  filtroEmpleados = signal<IEmpleadoData[]>([]);
  // métodos
  onBuscarEmpleado() {
    const busqueda = this.busquedaEmpleado().toLowerCase();
    if (busqueda.trim() === '') {
      this.filtroEmpleados.set(this.empleados());
    } else {
      const empleadosFiltrados = this.empleados().filter(
        (empleado) =>
          empleado.nombre_completo.toLowerCase().includes(busqueda) ||
          empleado.email.toLowerCase().includes(busqueda),
      );
      this.filtroEmpleados.set(empleadosFiltrados);
    }
  }
  onChangeEmpleado(empleadoActualizado: IEmpleadoData) {
    const empleadosActuales = this.empleados();
    const indice = empleadosActuales.findIndex((e) => e.id === empleadoActualizado.id);
    if (indice !== -1) {
      empleadosActuales[indice] = empleadoActualizado;
      this.empleados.set([...empleadosActuales]);
    }
  }
  closeCrearEmpleado(data?: IEmpleadoData) {
    this.modal_crear_empleado.set(false);
    if (data) {
      const empleadosActuales = this.empleados();
      empleadosActuales.push(data);
      this.empleados.set([...empleadosActuales]);
    }
  }
}
